import { useEffect } from "react";
import SalesList from "../components/SalesList";
import salesImg from "../assets/img/categories/3.png";

function SalePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <header className="position-relative w-100 pages-header">
        <h1 className="animate__animated animate__fadeInUp position-absolute text-white text-shadow categories-title w-100">
          On Sale
        </h1>
        <div className="gradient w-100"></div>
        <img
          className="img-fluid sales-header-img"
          src={salesImg}
          alt="imgCategory"
        />
      </header>
      <div className="container py-5">
        <SalesList productQty={1000} />
      </div>
    </>
  );
}
export default SalePage;
